import { mode, StyleFunctionProps } from '@chakra-ui/theme-tools'

import { shadows } from '~/theme/foundations'

const baseStyle = (props: StyleFunctionProps) => ({
  container: {
    bg: mode('white', 'gray.800')(props),
    borderRadius: 'lg',
    borderWidth: '1px',
    borderColor: mode('gray.50', 'gray.700')(props),
  },
})

const variants = {
  shadow: (props: StyleFunctionProps) => ({
    container: {
      shadow: mode(shadows.md, shadows['md-dark'])(props),
    },
  }),
  outline: () => ({
    container: {
      shadow: 'none',
      borderWidth: '1px',
      borderColor: 'border',
      borderStyle: 'solid',
    },
  }),
}

const defaultProps = {
  variant: 'shadow',
}

export default {
  baseStyle,
  variants,
  defaultProps,
}
